import request, { REQUEST_METHODS } from '@api/Request';
import { AuthorizedUserEndpoints } from './config';
import {
  AuthorizedUserResponse,
  BatchAuthorizedUsersPayload,
  GetAuthorizedUsersResponse,
  getProjectOwnerAndCurrentUserPermissionsResponse,
} from './types';

export default class AuthorizedUserService {
  public static readonly getAuthorizedUsers = (
    requestId: number,
    version: number
  ): Promise<GetAuthorizedUsersResponse> =>
    request({
      url: AuthorizedUserEndpoints.getAuthorizedUsers(),
      method: REQUEST_METHODS.GET,
      params: { requestId, version },
    });
  public static readonly bulkUpdateAuthorizedUsers = (
    requestId: number,
    version: number,
    data: BatchAuthorizedUsersPayload
  ): Promise<AuthorizedUserResponse> =>
    request({
      url: AuthorizedUserEndpoints.bulkUpdateAuthorizedUsers(requestId, version),
      method: REQUEST_METHODS.POST,
      data: { ...data },
    });
  public static readonly getProjectOwnerAndCurrentUserPermissions = (
    requestId: number,
    version: number
  ): Promise<getProjectOwnerAndCurrentUserPermissionsResponse> =>
    request({
      url: AuthorizedUserEndpoints.getProjectOwnerAndCurrentUserPermissions(),
      method: REQUEST_METHODS.GET,
      params: { requestId, version },
    });
}
